/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Whats_New_Category_FeatureInputs */

const vi_whats_new_category_feature = /** @type {(inputs: Whats_New_Category_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tính năng mới`)
};

/**

* @param {Whats_New_Category_FeatureInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const whats_new_category_feature = /** @type {((inputs?: Whats_New_Category_FeatureInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Whats_New_Category_FeatureInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_whats_new_category_feature(inputs)
});